/**
 * /search/:keyword — Keyword-targeted SEO landing pages
 * Jerkmate-style: /search/latina, /search/milf, /search/asian, etc.
 * Shows live performers matching the keyword + links to relevant category pages.
 */
import React, { useEffect, useState, useContext, useMemo } from "react";
import { useParams, Link } from "react-router-dom";
import { Box, Typography, Grid, Chip, Button, Skeleton } from "@mui/material";
import { PerformerContext } from "../contexts/PerformerContext";

// Map keyword → category page + display info
const KEYWORD_CONFIG = {
  latina: {
    title: "Latina Cam Girls",
    h1: "Watch Latina Cam Girls Live",
    desc: "Browse live Latina cam girls streaming right now. Colombian, Mexican, and Brazilian models in free chat 24/7.",
    metaTitle: "Latina Cam Girls Live — Watch Free | InstaCamGirls",
    metaDesc: "Watch live Latina cam girls now. Colombian, Mexican, Brazilian models streaming free 24/7. Chat or go private.",
    categoryHref: "/category/latina-cam-girls",
    categoryLabel: "All Latina Cam Girls",
    relatedCategories: [
      { label: "Latina Big Tits", href: "/category/latina-big-tits" },
      { label: "Latina MILF", href: "/category/latina-milf" },
      { label: "Latina Amateur", href: "/category/latina-amateur" },
    ],
    matchFn: (p) => p.ethnicity?.toLowerCase()?.includes("hispani") || p.ethnicity?.toLowerCase()?.includes("latin"),
  },
  milf: {
    title: "MILF Cam Girls",
    h1: "Watch MILF Cam Girls Live",
    desc: "Browse live MILF cam girls streaming right now. Mature women 30–50 who know exactly what they want.",
    metaTitle: "MILF Cam Girls Live — Watch Free | InstaCamGirls",
    metaDesc: "Watch live MILF cam girls now. Mature women 30–50 streaming free. Chat or go private.",
    categoryHref: "/category/milf-cam-girls",
    categoryLabel: "All MILF Cam Girls",
    relatedCategories: [
      { label: "MILF Big Tits", href: "/category/milf-big-tits" },
      { label: "Latina MILF", href: "/category/latina-milf" },
      { label: "Ebony MILF", href: "/category/ebony-milf" },
    ],
    matchFn: (p) => (p.age >= 30 && p.age <= 55),
  },
  ebony: {
    title: "Ebony Cam Girls",
    h1: "Watch Ebony Cam Girls Live",
    desc: "Browse live ebony cam girls streaming right now. Black models from the US, Caribbean, Africa, and Brazil.",
    metaTitle: "Ebony Cam Girls Live — Watch Free | InstaCamGirls",
    metaDesc: "Watch live ebony cam girls now. Black models streaming free 24/7. Chat or go private.",
    categoryHref: "/category/ebony-cam-girls",
    categoryLabel: "All Ebony Cam Girls",
    relatedCategories: [
      { label: "Ebony MILF", href: "/category/ebony-milf" },
      { label: "Ebony Amateur", href: "/category/ebony-amateur" },
      { label: "Big Ass Cams", href: "/category/big-ass-cam-girls" },
    ],
    matchFn: (p) => p.ethnicity?.toLowerCase()?.includes("ebony") || p.ethnicity?.toLowerCase()?.includes("black"),
  },
  asian: {
    title: "Asian Cam Girls",
    h1: "Watch Asian Cam Girls Live",
    desc: "Browse live Asian cam girls streaming right now. Japanese, Korean, Thai, Filipino models in free chat.",
    metaTitle: "Asian Cam Girls Live — Watch Free | InstaCamGirls",
    metaDesc: "Watch live Asian cam girls now. Japanese, Korean, Thai models streaming free. Chat or go private.",
    categoryHref: "/category/asian-cam-girls",
    categoryLabel: "All Asian Cam Girls",
    relatedCategories: [
      { label: "Asian Big Tits", href: "/category/asian-big-tits" },
      { label: "Asian Amateur", href: "/category/asian-amateur" },
      { label: "Teen Petite Cams", href: "/category/teen-petite" },
    ],
    matchFn: (p) => p.ethnicity?.toLowerCase()?.includes("asian"),
  },
  blonde: {
    title: "Blonde Cam Girls",
    h1: "Watch Blonde Cam Girls Live",
    desc: "Browse live blonde cam girls streaming right now. Natural and platinum blondes in free chat 24/7.",
    metaTitle: "Blonde Cam Girls Live — Watch Free | InstaCamGirls",
    metaDesc: "Watch live blonde cam girls now. Natural and platinum blondes streaming free. Chat or go private.",
    categoryHref: "/category/blonde-cam-girls",
    categoryLabel: "All Blonde Cam Girls",
    relatedCategories: [
      { label: "Blonde Big Tits", href: "/category/blonde-big-tits" },
      { label: "Redhead Cams", href: "/category/redhead-cam-girls" },
      { label: "Teen Cam Girls", href: "/category/teen-cam-girls" },
    ],
    matchFn: (p) => p.hairColor?.toLowerCase()?.includes("blond"),
  },
  brunette: {
    title: "Brunette Cam Girls",
    h1: "Watch Brunette Cam Girls Live",
    desc: "Browse live brunette cam girls streaming right now. Dark-haired models in free chat 24/7.",
    metaTitle: "Brunette Cam Girls Live — Watch Free | InstaCamGirls",
    metaDesc: "Watch live brunette cam girls now. Dark-haired models streaming free. Chat or go private.",
    categoryHref: "/category/brunette-cam-girls",
    categoryLabel: "All Brunette Cam Girls",
    relatedCategories: [
      { label: "Brunette Big Tits", href: "/category/brunette-big-tits" },
      { label: "Latina Cams", href: "/category/latina-cam-girls" },
      { label: "Mature Cam Girls", href: "/category/mature-cam-girls" },
    ],
    matchFn: (p) => p.hairColor?.toLowerCase()?.includes("brunette") || p.hairColor?.toLowerCase()?.includes("brown"),
  },
  feet: {
    title: "Feet Cam Girls",
    h1: "Watch Feet Cam Girls Live",
    desc: "Browse live cam girls offering foot fetish shows right now. Soles, arches, toes — all free to browse.",
    metaTitle: "Feet Cam Girls Live — Watch Free | InstaCamGirls",
    metaDesc: "Watch live feet cam girls now. Foot fetish performers streaming free. Chat or go private.",
    categoryHref: "/category/feet-cam-girls",
    categoryLabel: "All Feet Cam Girls",
    relatedCategories: [
      { label: "Amateur Feet", href: "/category/feet-amateur" },
      { label: "BDSM Cams", href: "/category/bdsm-cam-girls" },
      { label: "Submissive Cams", href: "/category/submissive-cam-girls" },
    ],
    matchFn: () => true, // show any performers
  },
  bdsm: {
    title: "BDSM Cam Girls",
    h1: "Watch BDSM Cam Girls Live",
    desc: "Browse live BDSM cam girls right now. Dominant, submissive, bondage, spanking performers in free chat.",
    metaTitle: "BDSM Cam Girls Live — Watch Free | InstaCamGirls",
    metaDesc: "Watch live BDSM cam girls now. Dominant and submissive performers streaming free.",
    categoryHref: "/category/bdsm-cam-girls",
    categoryLabel: "All BDSM Cam Girls",
    relatedCategories: [
      { label: "Dominant Cams", href: "/category/dominant-cam-girls" },
      { label: "Submissive Cams", href: "/category/submissive-cam-girls" },
      { label: "Roleplay Cams", href: "/category/roleplay-cam-girls" },
    ],
    matchFn: () => true,
  },
  squirt: {
    title: "Squirt Cam Girls",
    h1: "Watch Squirt Cam Girls Live",
    desc: "Browse live squirt cam girls streaming right now. Real wet show performers in free chat.",
    metaTitle: "Squirt Cam Girls Live — Watch Free | InstaCamGirls",
    metaDesc: "Watch live squirt cam girls now. Real wet show performers streaming free.",
    categoryHref: "/category/squirt-cam-girls",
    categoryLabel: "All Squirt Cam Girls",
    relatedCategories: [
      { label: "Amateur Squirt", href: "/category/squirt-amateur" },
      { label: "Interactive Toys", href: "/category/interactivetoy-cam-girls" },
      { label: "Latina Cams", href: "/category/latina-cam-girls" },
    ],
    matchFn: () => true,
  },
  amateur: {
    title: "Amateur Cam Girls",
    h1: "Watch Amateur Cam Girls Live",
    desc: "Browse live amateur cam girls streaming right now. Real girl-next-door performers. No scripts, no studios.",
    metaTitle: "Amateur Cam Girls Live — Watch Free | InstaCamGirls",
    metaDesc: "Watch live amateur cam girls now. Real unscripted performers streaming free.",
    categoryHref: "/category/amateur-cam-girls",
    categoryLabel: "All Amateur Cam Girls",
    relatedCategories: [
      { label: "Latina Amateur", href: "/category/latina-amateur" },
      { label: "Asian Amateur", href: "/category/asian-amateur" },
      { label: "Ebony Amateur", href: "/category/ebony-amateur" },
    ],
    matchFn: () => true,
  },
  petite: {
    title: "Petite Cam Girls",
    h1: "Watch Petite Cam Girls Live",
    desc: "Browse live petite cam girls streaming right now. Slim, small-framed performers in free chat.",
    metaTitle: "Petite Cam Girls Live — Watch Free | InstaCamGirls",
    metaDesc: "Watch live petite cam girls now. Slim small-framed models streaming free.",
    categoryHref: "/category/petite-cam-girls",
    categoryLabel: "All Petite Cam Girls",
    relatedCategories: [
      { label: "Teen Petite", href: "/category/teen-petite" },
      { label: "Asian Cam Girls", href: "/category/asian-cam-girls" },
      { label: "Teen Cams 18+", href: "/category/teen-cam-girls" },
    ],
    matchFn: (p) => p.build?.toLowerCase()?.includes("petite") || p.build?.toLowerCase()?.includes("slim"),
  },
  mature: {
    title: "Mature Cam Girls",
    h1: "Watch Mature Cam Girls Live",
    desc: "Browse live mature cam girls 40+ streaming right now. Experienced women in free chat 24/7.",
    metaTitle: "Mature Cam Girls Live 40+ — Watch Free | InstaCamGirls",
    metaDesc: "Watch live mature cam girls 40+ now. Experienced women streaming free.",
    categoryHref: "/category/mature-cam-girls",
    categoryLabel: "All Mature Cam Girls",
    relatedCategories: [
      { label: "Mature Big Tits", href: "/category/mature-big-tits" },
      { label: "MILF Cam Girls", href: "/category/milf-cam-girls" },
      { label: "BBW Cam Girls", href: "/category/bbw-cam-girls" },
    ],
    matchFn: (p) => p.age >= 40,
  },
  teen: {
    title: "Teen Cam Girls (18+)",
    h1: "Watch Teen Cam Girls Live (18+)",
    desc: "Browse live 18+ teen cam girls streaming right now. All performers age-verified adults.",
    metaTitle: "Teen Cam Girls 18+ Live — Watch Free | InstaCamGirls",
    metaDesc: "Watch live teen cam girls 18+ now. Age-verified adult performers streaming free.",
    categoryHref: "/category/teen-cam-girls",
    categoryLabel: "All Teen Cam Girls",
    relatedCategories: [
      { label: "Teen Petite", href: "/category/teen-petite" },
      { label: "Asian Amateur", href: "/category/asian-amateur" },
      { label: "College Cams", href: "/category/college-cam-girls" },
    ],
    matchFn: (p) => p.age >= 18 && p.age <= 23,
  },
  lesbian: {
    title: "Lesbian Cam Shows",
    h1: "Watch Lesbian Cam Shows Live",
    desc: "Browse live lesbian cam shows streaming right now. Girl-on-girl shows in free chat 24/7.",
    metaTitle: "Lesbian Cam Shows Live — Watch Free | InstaCamGirls",
    metaDesc: "Watch live lesbian cam shows now. Girl-on-girl performances streaming free.",
    categoryHref: "/category/couples-cam",
    categoryLabel: "Browse Lesbian Cams",
    relatedCategories: [
      { label: "Couples Cams", href: "/category/couples-cam" },
      { label: "Amateur Cams", href: "/category/amateur-cam-girls" },
      { label: "Roleplay Cams", href: "/category/roleplay-cam-girls" },
    ],
    matchFn: () => true,
  },
  "big-tits": {
    title: "Big Tits Cam Girls",
    h1: "Watch Big Tits Cam Girls Live",
    desc: "Browse live busty cam girls streaming right now. Natural and enhanced big tits in free chat 24/7.",
    metaTitle: "Big Tits Cam Girls Live — Watch Free | InstaCamGirls",
    metaDesc: "Watch live big tits cam girls now. Busty models streaming free. Chat or go private.",
    categoryHref: "/category/big-tits-cam-girls",
    categoryLabel: "All Big Tits Cam Girls",
    relatedCategories: [
      { label: "Latina Big Tits", href: "/category/latina-big-tits" },
      { label: "Blonde Big Tits", href: "/category/blonde-big-tits" },
      { label: "MILF Big Tits", href: "/category/milf-big-tits" },
    ],
    matchFn: (p) => p.bust?.toLowerCase()?.includes("large") || p.bust?.toLowerCase()?.includes("big"),
  },
  "big-ass": {
    title: "Big Ass Cam Girls",
    h1: "Watch Big Ass Cam Girls Live",
    desc: "Browse live thick curvy cam girls streaming right now. Big booty performers twerking in free chat.",
    metaTitle: "Big Ass Cam Girls Live — Watch Free | InstaCamGirls",
    metaDesc: "Watch live big ass cam girls now. Thick curvy models streaming free. Chat or go private.",
    categoryHref: "/category/big-ass-cam-girls",
    categoryLabel: "All Big Ass Cam Girls",
    relatedCategories: [
      { label: "Ebony Cams", href: "/category/ebony-cam-girls" },
      { label: "Latina Cams", href: "/category/latina-cam-girls" },
      { label: "BBW Cams", href: "/category/bbw-cam-girls" },
    ],
    matchFn: () => true,
  },
  redhead: {
    title: "Redhead Cam Girls",
    h1: "Watch Redhead Cam Girls Live",
    desc: "Browse live redhead cam girls streaming right now. Fiery gingers and natural redheads in free chat.",
    metaTitle: "Redhead Cam Girls Live — Watch Free | InstaCamGirls",
    metaDesc: "Watch live redhead cam girls now. Fiery ginger models streaming free. Chat or go private.",
    categoryHref: "/category/redhead-cam-girls",
    categoryLabel: "All Redhead Cam Girls",
    relatedCategories: [
      { label: "Redhead Big Tits", href: "/category/redhead-big-tits" },
      { label: "Blonde Cams", href: "/category/blonde-cam-girls" },
      { label: "Brunette Cams", href: "/category/brunette-cam-girls" },
    ],
    matchFn: (p) => p.hairColor?.toLowerCase()?.includes("red"),
  },
  "natural-tits": {
    title: "Natural Tits Cam Girls",
    h1: "Watch Natural Tits Cam Girls Live",
    desc: "Browse live all-natural cam girls streaming right now. No implants, real bodies in free chat.",
    metaTitle: "Natural Tits Cam Girls Live — Watch Free | InstaCamGirls",
    metaDesc: "Watch live natural tits cam girls now. All-natural bodies streaming free.",
    categoryHref: "/category/natural-tits-cam-girls",
    categoryLabel: "All Natural Tits Cam Girls",
    relatedCategories: [
      { label: "Amateur Cams", href: "/category/amateur-cam-girls" },
      { label: "Teen Cams 18+", href: "/category/teen-cam-girls" },
      { label: "Blonde Cams", href: "/category/blonde-cam-girls" },
    ],
    matchFn: () => true,
  },
  couples: {
    title: "Couples Cam Shows",
    h1: "Watch Live Couples Cam Shows",
    desc: "Browse live couples streaming right now. Real couples performing live in free chat 24/7.",
    metaTitle: "Couples Cam Shows Live — Watch Free | InstaCamGirls",
    metaDesc: "Watch live couples cam shows now. Real couples streaming free. Chat or go private.",
    categoryHref: "/category/couples-cam",
    categoryLabel: "All Couples Cams",
    relatedCategories: [
      { label: "Amateur Cams", href: "/category/amateur-cam-girls" },
      { label: "MILF Cams", href: "/category/milf-cam-girls" },
      { label: "Ebony Cams", href: "/category/ebony-cam-girls" },
    ],
    matchFn: () => true,
  },
  interactivetoy: {
    title: "Interactive Toy Cam Girls",
    h1: "Control Her Vibe — Interactive Toy Cams Live",
    desc: "Browse live interactive toy cam girls right now. Control her vibrator with tips in real time.",
    metaTitle: "Interactive Toy Cam Girls Live — Control the Vibe | InstaCamGirls",
    metaDesc: "Watch live interactive toy cam girls now. Control the vibrator with your tips in real time.",
    categoryHref: "/category/interactivetoy-cam-girls",
    categoryLabel: "All Interactive Toy Cams",
    relatedCategories: [
      { label: "Lovense Cams", href: "/category/lovense-cams" },
      { label: "Squirt Cams", href: "/category/squirt-cam-girls" },
      { label: "Latina Cams", href: "/category/latina-cam-girls" },
    ],
    matchFn: () => true,
  },
};

// Tile component for a performer
const PerformerTile = ({ p }) => (
  <Box
    component={Link}
    to={`/cam/${p.name}`}
    sx={{
      display: "block",
      textDecoration: "none",
      borderRadius: 2,
      overflow: "hidden",
      position: "relative",
      aspectRatio: "4/3",
      background: "#111",
      "&:hover img": { transform: "scale(1.05)" },
    }}
  >
    <Box
      component="img"
      src={p.previewUrl || p.thumbnailUrl}
      alt={`${p.name} live cam`}
      sx={{ width: "100%", height: "100%", objectFit: "cover", transition: "transform 0.3s" }}
      onError={(e) => { e.target.style.display = "none"; }}
    />
    <Box
      sx={{
        position: "absolute", bottom: 0, left: 0, right: 0,
        background: "linear-gradient(to top, rgba(0,0,0,0.8) 0%, transparent 100%)",
        p: 1.5,
      }}
    >
      <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: 13 }}>{p.name}</Typography>
      {p.age && (
        <Typography sx={{ color: "#ccc", fontSize: 11 }}>{p.age} yrs</Typography>
      )}
    </Box>
    <Box
      sx={{
        position: "absolute", top: 8, left: 8,
        background: "#e91e63", borderRadius: 1,
        px: 0.75, py: 0.25,
      }}
    >
      <Typography sx={{ color: "#fff", fontSize: 10, fontWeight: 700 }}>LIVE</Typography>
    </Box>
  </Box>
);

const SearchLandingPage = () => {
  const { keyword } = useParams();
  const config = KEYWORD_CONFIG[keyword?.toLowerCase()];
  const { performers, loading } = useContext(PerformerContext);

  const matchedPerformers = useMemo(() => {
    if (!performers || !config) return [];
    const filtered = performers.filter(config.matchFn);
    return filtered.slice(0, 24);
  }, [performers, config]);

  useEffect(() => {
    if (!config) return;
    document.title = config.metaTitle;
    const setMeta = (name, content) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.name = name; document.head.appendChild(el); }
      el.content = content;
    };
    const setOg = (prop, content) => {
      let el = document.querySelector(`meta[property="${prop}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("property", prop); document.head.appendChild(el); }
      el.content = content;
    };
    setMeta("description", config.metaDesc);
    setOg("og:title", config.metaTitle);
    setOg("og:description", config.metaDesc);
    let canon = document.querySelector("link[rel='canonical']");
    if (!canon) { canon = document.createElement("link"); canon.rel = "canonical"; document.head.appendChild(canon); }
    canon.href = `https://instacamgirls.com/search/${keyword}`;
  }, [config, keyword]);

  if (!config) {
    return (
      <Box sx={{ maxWidth: 900, mx: "auto", px: 2, py: 6, textAlign: "center" }}>
        <Typography variant="h5">No results for "{keyword}"</Typography>
        <Button component={Link} to="/" variant="contained" sx={{ mt: 3 }}>Browse All Live Cams</Button>
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 1100, mx: "auto", px: 2, py: 4 }}>
      {/* SEO Header */}
      <Typography variant="h4" component="h1" sx={{ fontWeight: 800, mb: 1 }}>
        {config.h1}
      </Typography>
      <Typography sx={{ color: "#555", mb: 3, maxWidth: 600 }}>
        {config.desc}
      </Typography>

      {/* Related categories */}
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 4 }}>
        <Chip
          label={config.categoryLabel}
          component={Link}
          to={config.categoryHref}
          clickable
          sx={{ fontWeight: 700, backgroundColor: "#e91e63", color: "#fff" }}
        />
        {config.relatedCategories.map((cat) => (
          <Chip key={cat.href} label={cat.label} component={Link} to={cat.href} clickable />
        ))}
      </Box>

      {/* Live performer grid */}
      {loading ? (
        <Grid container spacing={2}>
          {Array.from({ length: 12 }).map((_, i) => (
            <Grid item xs={6} sm={4} md={3} key={i}>
              <Skeleton variant="rectangular" sx={{ borderRadius: 2, aspectRatio: "4/3" }} />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Grid container spacing={2}>
          {matchedPerformers.map((p) => (
            <Grid item xs={6} sm={4} md={3} key={p.name}>
              <PerformerTile p={p} />
            </Grid>
          ))}
        </Grid>
      )}

      {/* CTA */}
      <Box sx={{ mt: 5, textAlign: "center" }}>
        <Button
          component={Link}
          to={config.categoryHref}
          variant="contained"
          size="large"
          sx={{ backgroundColor: "#e91e63", fontWeight: 700 }}
        >
          See All {config.title} →
        </Button>
      </Box>

      {/* SEO Footer text */}
      <Box sx={{ mt: 6, p: 3, background: "#f9f9f9", borderRadius: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
          About {config.title}
        </Typography>
        <Typography sx={{ color: "#555", lineHeight: 1.8, fontSize: 14 }}>
          InstaCamGirls features hundreds of {config.title.toLowerCase()} streaming live 24/7. 
          Free chat is always open — no sign-up required to browse. When you find a performer you love, 
          creating a free account takes under a minute, unlocking tips, private shows, and more.
        </Typography>
      </Box>
    </Box>
  );
};

export default SearchLandingPage;
